import { request } from "../../api";

export interface DeviceNetworkPolicyDetail {
  id: string;
  version: number;
  payload_hash: string;
  policy_hash: string;
  compiled_at: string;
  compiled_by_reason: string;
  acknowledged_at: string | null;
  acknowledged_app_version: string;
  name?: string | null;
  policy_id?: string | null;
  default_action: string;
  allow_count: number;
  block_count: number;
  payload: Record<string, unknown>;
}

export const deviceNetworkPolicyApi = {
  get: (deviceId: string, version?: number) => {
    const query = version !== undefined ? `?version=${version}` : "";
    return request<DeviceNetworkPolicyDetail>(
      `/api/admin/v1/devices/${deviceId}/network-policy/${query}`,
    );
  },
};
